import { render, staticRenderFns } from "./DynamicResultRelease.vue?vue&type=template&id=44a9e8d6&lang=pug"
import script from "./DynamicResultRelease.vue?vue&type=script&lang=js"
export * from "./DynamicResultRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports